export const addTrailingSlash = (str: string) => (str?.at && str.at(-1) === '/' ? str : str + '/');
